import { useContext } from 'react';

import { CommandLauncherCreateActionFn } from '../commandLauncher.types';
import {
  CommandLauncherContext,
  CommandLauncherContextValue,
} from '../commandLauncherContext';
import { createCommandLauncherAction } from '../createCommandLauncherAction/createCommandLauncherAction';

type UseCommandLauncherResult = CommandLauncherContextValue & {
  /** The function for creating an action. */
  readonly createAction: CommandLauncherCreateActionFn;
};

export const useCommandLauncher = (): UseCommandLauncherResult => {
  const context = useContext(CommandLauncherContext);

  return {
    ...context,
    createAction: createCommandLauncherAction,
  };
};
